type CompanyCurrencies = {
  fComDefaultCurrency: string;
  fComSupportedCurrencies: string[];
};

export enum PublicCustomDataOptions {
  EMPLOYEE_POS = 'EMPLOYEE_POS',
  EMPLOYEE = 'EMPLOYEE',
}

export interface CompanyDataLeaveTypes {
  fComVacationLeaveTypes: string[];
  fComSickLeaveTypes: string[];
  fComVacationLeaveExtraTypes: string[];
  fComVacationBankLeaveTypes1: string[];
  fComVacationBankLeaveTypes2: string[];
  fComVacationBankLeaveTypes3: string[];
  fComPublicLeaveTypes: string[];
  fComYearlyVacationBalanceTypes: string[];
  fComOverlappingAbsencesTypes: string[];
  fComSickLeaveCountLimit: { limit: number; reset: string };
  fComSickLeaveTypesDayLimit: { type: string; limit: number }[];
}

export interface CompanyDataConfig {
  fComDefaultWorkReportingType: string;
  fComHrGeneralContacts: string[];
  fComLeaveTypes: CompanyDataLeaveTypes;
  fComTmWorkdayLengthHours: string;
  fComFormerEmployeeDataEditingLimit: number;
  fComMaxPersonnelGroups: number;
  fComPublicCustomdata: PublicCustomDataOptions[];
}

export interface CompanyDataLanguage {
  fComLanguageCode: string;
  fComLanguageName: string;
  fComLanguageIsDefault: boolean;
}

export interface CompanyLogoData {
  fComLogoAltText: string;
  fComLogoId: string;
  fComUseLogo: boolean;
}

export type CompanyData = {
  config: CompanyDataConfig;
  logo: CompanyLogoData;
  languages?: CompanyDataLanguage[];
  currencies: CompanyCurrencies;
  fComAddress1: string;
  fComAddress2: string;
  fComCity: string;
  fComCountry: string;
  fComName: string;
  fComPOBox: string;
  fComPostalCode: string;
  fComState: string;
};

export type CompanyMessage = {
  fCompanyMessage: string;
  fCompanyMessageUpdatedTime: string;
};

type EmailDataItem = {
  address: string;
};

export type SendEmailData = {
  body: string;
  subject: string;
  to: {
    employees?: number[];
    units?: number[];
    emails?: EmailDataItem[];
  };
};
